module.exports = __webpack_public_path__ + "img/repair-desk2.7d3f780d.jpg";